module.exports = __webpack_public_path__ + "static/media/selected_icn_map_event_H.b7bb0c9c.svg";